import Vue from 'vue'
import VueMoment from 'vue-moment'
import Vuelidate from 'vuelidate'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store/store'
import { i18n } from '@/plugins/i18n'
import api from '@/api'
import VueAxios from 'vue-axios'
import VueMask from 'v-mask'
import moment from 'moment-timezone'
import VueColumnsResizable from 'vue-columns-resizable';
import VueCollapse from '@/widgets/vue-collapse/src';
import Maximizable from '@/widgets/maximizable';

import 'select2-vue-component'
import '@/assets/style.css'
import '@/assets/style.scss';

import InputCost from '@/widgets/input-cost'
import InputNumber from '@/widgets/input-number'
import InputFloat from '@/widgets/input-float'
import InputPercent from '@/widgets/input-percent'
import InputEstimation from '@/widgets/input-estimation'
import InputFile from '@/widgets/input-file'
import LivesearchDropdown from '@/widgets/livesearch-dropdown'
import DateTime from '@/widgets/datetime'
import Modal from '@/widgets/modal'
import Draggable from '@/widgets/draggable'
import Dropdown from '@/widgets/dropdown'
import DropdownNew from '@/widgets/dropdown-new'
import VTooltip from '@/widgets/v-tooltip'
import FileLink from '@/widgets/file-link'
import ExpandableList from '@/widgets/expandable-list'
import FilePicker from '@/components/common/inputs/FilePicker'
import DatePicker from '@/widgets/date-picker-2'
import Popover from '@/widgets/popover'
import Timer from '@/widgets/timer'
import ExtendedModal from 'vue-js-modal'
import xss from 'xss'
import { saveAs } from 'file-saver';
import Loading from '@/components/Loading'
import _ from "lodash";

import Errors from '@/api/types/errors'
import enums from '@/api/enums'

Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(VueColumnsResizable);
Vue.use(VueCollapse);
Vue.use(Maximizable);
Vue.use(VueMoment, {
  moment,
});
Vue.use(ExtendedModal, { componentName: 'extended-modal' })

Vue.use(VueAxios, api);

Vue.filter('ticksToMillis', function (value) {
  if (!value || typeof value !== 'number') return;
  return value;
});

Vue.filter('shortList', function(list, limit) {
  let out = (limit ? list.slice(0, limit) : list).join(', ');

  if (limit && list.length > limit) {
    out += ', ...';
  }

  return out;
});

Vue.filter('fullList', function(list) {
  return list.join(', ');
});

Vue.filter('percent', function(value) {
  if (value === undefined) return;

  value = value.toString();
  if (typeof value !== 'string') return;

  const f = value.slice(-2);
  let v = value.slice(0, -2) || '0';

  if (+f) {
    v += ',' + ('00' + f).slice(-2);
  }

  return v;
});

Vue.filter('price', function(value) {
  if (value === undefined || value === '') return;
  value = Math.round(value).toString();
  if (typeof value !== 'string') return;

  const f = value.slice(-2);
  let v = +value.slice(0, -2);
  let str = [];

  if (_.isFinite(v)) {
    if (v === 0) {
      str.push(0);
    }

    while (v > 0) {
      str.unshift(v % 1000);
      v = Math.trunc(v / 1000);
    }

    str = str.map((v, i) => {
      if (i === 0) return v;
      return ('000' + v).slice(-3);
    })
  }

  str = str.join(' ');

  if (+f) {
    str += ',' + ('00' + f).slice(-2);
  }

  return str;
});

Vue.filter('present-price', function(value) {
  if (value === undefined) return;
  value = parseFloat(value);
  if (isNaN(value)) return;

  return value.toFixed(2);
});

Vue.filter('defaultValue', function(value, text, undefinedValue) {
  if (value === undefinedValue) {
    return text || '';
  }

  return value;
});

Vue.filter('estimation', function(value) {
  if (value === undefined) return;
  value = value.toString();

  if (typeof value !== 'string') return;

  const n = +value;

  return (n / 1000.0).toFixed(3);
});

Vue.filter('finalEstimation', function(value) {
  if (value === undefined) return;
  value = value.toString();
  if (typeof value !== 'string') return;

  const n = +value;

  return (n / 10000000.0).toFixed(2);
});

Vue.filter('fullName', function(value) {
  if (typeof value !== 'object') return;
  return [value.lastName, value.firstName, value.middleName].join(' ');
});

Vue.filter('toHtml', function(value) {
  return (value + '').replace(/(?:\r\n|\r|\n)/g, '<br>');
});

Vue.filter('get', function(value, path, def) {
  return _.get(value, path, def)
});

Vue.mixin({
  data: () => ({
    api: process.env.VUE_APP_API_URL,

    config: {
      links: {
        regulations: process.env.VUE_APP_API_URL + '/system/Reglament',
        agreement: process.env.VUE_APP_API_URL + '/system/Soglashenie',
        guide: process.env.VUE_APP_API_URL + '/system/Instruction',
        signature: process.env.VUE_APP_API_URL + '/system/Ep'
      },

      customer: {
        title: process.env.VUE_APP_CUSTOMER_TITLE,
        address: process.env.VUE_APP_CUSTOMER_ADDRESS
      }
    }
  }),

  computed: {
    customerAddress: {
      get() {
        return this.$store.getters.companyAddress || this.config.customer.address;
      }
    },

    customerTitle: {
      get() {
        return this.$store.getters.companyTitle || this.config.customer.title;
      }
    },

    enums: {
      get() {
        return enums;
      }
    }
  },

  methods: {
    saveTextAs(text, filename) {
      const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
      saveAs(blob, filename);
    }
  }
});



Vue.mixin({
  data: () => ({
    loading: false
  }),

  components: {
    InputCost
    , InputNumber
    , InputFloat
    , InputPercent
    , InputEstimation
    , InputFile
    , LivesearchDropdown
    , DateTime
    , Modal
    , Draggable
    , Dropdown
    , DropdownNew
    , FileLink
    , FilePicker
    , DatePicker
    , ExpandableList
    , Timer
    , Loading
    , Popover
  },

  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },

    currentOrganization() {
      return this.$store.getters.currentOrganization;
    },

    currentAccreditation() {
      return this.$store.getters.currentAccreditation;
    }
  },

  methods: {
    escape(value) {
      return xss(value).replace(/(?:\r\n|\r|\n)/g, '<br>');
    },

    goUp() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },

    runAction(action) {
      const timer = setTimeout(() => {
        this.loading = true;
        this.$emit('loading', true);
      }, 200);

      const stopAction = () => {
        clearTimeout(timer);
        this.loading = false;
        this.$emit('loading', false);
      };

      const ret = action.call(this);

      if (ret instanceof Promise) {
        ret.then(stopAction).catch(stopAction);
      } else {
        stopAction();
      }

      return ret;
    },

    runBlockerAction(action) {
      let locked = false;
      const timer = setTimeout(() => { locked = true; this.$store.commit('lockScreen') }, 100);

      const stopAction = () => {
        clearTimeout(timer);
        if (locked) {
          this.$store.commit('unlockScreen');
        }
      };

      const ret = action.call(this);

      if (ret instanceof Promise) {
        ret.then(stopAction).catch(stopAction);
      } else {
        stopAction();
      }

      return ret;
    },

    askConfirmation({title, body, onConfirm, onCancel}) {
      const dialog = _.get(this.$root, '$children[0].$refs.simple-confirmation');

      if (dialog) {
        dialog.open({
          title,
          text: body,
          onConfirm,
          onCancel
        })
      }
    },

    showError({ title, error, details }) {
      this.$store.dispatch('raiseGlobalError', { title, error, details });
    },

    unknownErrorHandler(error) {
      if (error instanceof Errors) {
        this.showError({
          error: this.$t(error.label) || 'errors.unknown'
        });
      }
      else {
        this.showError({
          error: 'errors.unknown'
        });
      }
    },

    globalErrorHandler(error, errors, defaultError, title) {
      if (error instanceof Errors && _.has(errors, error.toString())) {
        this.showError({
          error: this.$t(errors[error.toString()])
        });
      }
      else if (defaultError) {
        this.showError({
          error: defaultError
        });
      }
      else {
        this.unknownErrorHandler(error);
      }
    },

    externalLink(path) {
      if (path instanceof File) {
        return URL.createObjectURL(path);
      }

      return `${process.env.VUE_APP_STORAGE_URL}/${path}`;
    },

    fileSize(value) {
      let num = +value;
      if (typeof num !== 'number' || isNaN(num)) {
        throw new TypeError('Expected a number');
      }

      const labels = [
        { limit: 1024, precision: 0, label: 'size.bytes'},
        { limit: 1024 * 1024, precision: 1, label: 'size.kbytes'},
        { limit: Infinity, precision: 2, label: 'size.mbytes'}
      ];

      let index = 0;
      for (; index < labels; ++index) {
        if (num < labels[index].limit) {
          break;
        }
      }

      index = Math.min(index, labels.length - 1);

      const base = (index == 0 ? 1 : labels[index - 1].limit);
      const info = labels[index];

      return { path: 'size.bytes', args: { size: (num / base).toFixed(info.precision) } };
    }
  }
});

new Vue({
  router,
  store,
  i18n,
  el: '#app',
  render: h => h(App)
});
